import React from 'react';

// Import section components
import Hero from '../components/home/Hero';
import Features from '../components/home/Features';
import CallToAction from '../components/home/CallToAction';

const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <Features />
      <CallToAction />
    </>
  );
};

export default Home;
